<div class='carousel-holder' *ngIf="carouselData">
    <ngb-carousel [showNavigationArrows]="true" [showNavigationIndicators]="true">  
        <ng-template ngbSlide *ngFor="let item of carouselData">  
            <img src="{{ item.image }}" alt="slide">
            <span class="title" *ngIf="item.title">{{ item.title }}</span>
            <span class="description" *ngIf="item.description">{{ item.description }}</span>
        </ng-template>
    </ngb-carousel>
</div> 
